import React from "react";
import {OAuth} from './pages/OAuth';
import {Route} from 'react-router-dom';
import Layout from './pages/Layout';
import {PrivateRoute} from "./utils/PrivateRoute";
import {routePath} from "./router/paths";


export const App = (props) => {
  const {location} = props;
  return (
    <React.Fragment>
      {location && location.pathname !== routePath.AUTH &&
      <PrivateRoute
        component={Layout}
        path='/'
      />}
      <Route
        component={OAuth}
        path={routePath.AUTH}
      />

    </React.Fragment>
  );
}
